import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { I18NextModule } from 'angular-i18next';

@Component({
  standalone: true,
  selector: 'app-cancel-with-reason-modal',
  templateUrl: './cancel-with-reason-modal.component.html',
  styleUrls: ['./cancel-with-reason-modal.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    I18NextModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class CancelWithReasonModalComponent {
  @Output() confirmCancelOrderEmitter = new EventEmitter<boolean>();
  cancelForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<CancelWithReasonModalComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      text: string;
    }
  ) {
    this.cancelForm = this.fb.group({
      reason: ['', Validators.required]
    });
  }

  confirmCancel() {
    this.dialogRef.close();
    const reasonValue = this.cancelForm.get('reason')?.value;
    this.dialogRef.close();
    this.confirmCancelOrderEmitter.emit(reasonValue);
  }
}
